import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sjan-raisoni-achievers-award',
  templateUrl: './sjan-raisoni-achievers-award.component.html',
  styleUrls: ['./sjan-raisoni-achievers-award.component.scss']
})
export class SjanRaisoniAchieversAwardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
